var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file-alt",
    "data-name": "Icon awesome-file-alt",
    d: "M35,21.25V0H3.75A3.741,3.741,0,0,0,0,3.75v72.5A3.741,3.741,0,0,0,3.75,80h52.5A3.741,3.741,0,0,0,60,76.25V25H38.75A3.761,3.761,0,0,1,35,21.25ZM45,58.125A1.881,1.881,0,0,1,43.125,60H16.875A1.881,1.881,0,0,1,15,58.125v-1.25A1.881,1.881,0,0,1,16.875,55h26.25A1.881,1.881,0,0,1,45,56.875Zm0-10A1.881,1.881,0,0,1,43.125,50H16.875A1.881,1.881,0,0,1,15,48.125v-1.25A1.881,1.881,0,0,1,16.875,45h26.25A1.881,1.881,0,0,1,45,46.875Zm0-11.25v1.25A1.881,1.881,0,0,1,43.125,40H16.875A1.881,1.881,0,0,1,15,38.125v-1.25A1.881,1.881,0,0,1,16.875,35h26.25A1.881,1.881,0,0,1,45,36.875ZM60,19.047V20H40V0h.953a3.747,3.747,0,0,1,2.656,1.094l15.3,15.313A3.738,3.738,0,0,1,60,19.047Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileText);
export default __webpack_public_path__ + "static/media/fileText.526760bee3c963d67ad3518f0994980f.svg";
export { ForwardRef as ReactComponent };